import { HttpClient, HttpResponse } from "@angular/common/http";
import {RestUrlsConfig} from "@signature-it/ngx-generic/config";
import {CommonService} from "./common.service";
import {catchError, map, tap} from "rxjs/operators";
import {Observable, throwError} from "rxjs";
import {Injectable} from "@angular/core";
import { PageNotificationService } from './page-notification';
import { GalleryItemDTO } from '@signature-it/ngx-generic/models';

@Injectable({
	providedIn: 'root'
})
export class CarouselService extends CommonService {

	playPause = false;

	constructor(protected http: HttpClient,
				protected restUrlsConf: RestUrlsConfig,
				protected notifySvc: PageNotificationService) {
		super(http, restUrlsConf, notifySvc);
	}

    setPlay(carouselEl, slidersInterval): void {
        carouselEl.interval = slidersInterval;
        this.playPause = false;
    }

    setPause(carouselEl): void {
        carouselEl.interval = 0;
        this.playPause = true;
    }

	getGalleryFromApi(url: string): Observable<GalleryItemDTO[]> {
		return this.http.get(`${this.restUrlsConf.appURL}/${url}`)
			.pipe(map((res: any[]) =>  {
				const data = res || [];
				return GalleryItemDTO.createFromArray(data);
			}), catchError( (error: any) => throwError(error)));
	}

	getDataFromApi(url: string) {
		return this.http.get(`${this.restUrlsConf.appURL}/${url}`)
			.pipe(map((res: any[]) =>  {
				const data = res || [];
				return data;
			}), catchError( (error: any) => throwError(error)));
	}

}
